/**
 * What the Guide step says about its coverage check, and what it sends Sigora from it: one module,
 * so the product copy is one file to change. Placeholder copy.
 */

/** The button in the check's notice that asks Sigora, in the step's conversation, to fix it. */
export const COVERAGE_FIX_LABEL = 'Help me fix this';

/** Under a redraft that found nothing to change in the guide on screen. */
export const COVERAGE_REDRAFT_UNCHANGED =
  'Sigora’s last redraft found no change to the guide that answers these research questions. Use “Help me fix this”, or redraft again.';

/** Beside the button that redrafts the guide for the lines the check shows. */
export const COVERAGE_REDRAFT_OFFER =
  'Or have Sigora redraft the guide for these research questions. It changes or adds only the questions they need and keeps your wording wherever it can.';

export { coverageFixMessage } from '@sigora/domain';
